import React from "react";
import { useUXUYWallet } from "~/Provider/UXUYWallet";
import WalletNotConnect from "./WalletNotConnect";
import WalletAssets from "./WalletAssets";

const BalancePage: React.FC = () => {
    const { isConnected } = useUXUYWallet();

    if (!isConnected()) {
        return <WalletNotConnect />;
    }

    return <WalletAssets />;
};

export default BalancePage;
